import LegalLayout from "./_LegalLayout";

export default function Termini() {
    return (
        <LegalLayout title="Termini e Condizioni" subtitle="Condizioni generali di servizio 7MED.ch">
            <p className="text-sm text-ink-muted">Ultimo aggiornamento: dicembre 2025</p>

            <h2>1. Oggetto</h2>
            <p>Le presenti Condizioni Generali disciplinano l'utilizzo del sito 7med.ch e l'erogazione dei corsi e servizi forniti da 7MED GROUP (di seguito "7MED").</p>

            <h2>2. Iscrizione ai corsi</h2>
            <p>L'iscrizione si perfeziona con la conferma scritta da parte di 7MED. Le date e le modalità di erogazione sono comunicate via email. 7MED si riserva di posticipare o annullare un corso qualora non si raggiunga il numero minimo di partecipanti, con preavviso di almeno 48 ore.</p>

            <h2>3. Prezzi e pagamento</h2>
            <p>I prezzi indicati sul sito sono in CHF. Per i privati il pagamento avviene tramite bonifico bancario o sul posto secondo accordi. Per le aziende viene emessa fattura con termine 30 giorni.</p>

            <h2>4. Disdette e rimborsi</h2>
            <ul>
                <li>Disdetta con preavviso di almeno <strong>36 ore</strong> prima della data del corso: nessun addebito, il partecipante può disiscriversi liberamente.</li>
                <li>Disdetta con preavviso <strong>inferiore alle 36 ore</strong> o mancata presentazione senza preavviso: addebito dell'importo <strong>completo</strong> del corso.</li>
                <li>In caso di malattia ogni situazione viene valutata singolarmente da 7MED, caso per caso.</li>
            </ul>
            <p>Per qualsiasi comunicazione ufficiale relativa a disdette, riprogrammazioni o richieste (inclusi certificati medici) è necessario scrivere esclusivamente a <a href="mailto:backoffice@7med.ch">backoffice@7med.ch</a>. Comunicazioni inviate tramite altri canali (telefono, WhatsApp, social) non sono considerate ufficiali e non producono effetti sulla disdetta.</p>

            <h2>5. Certificazioni</h2>
            <p>I certificati SRC sono validi 2 anni dalla data del corso. La validità è subordinata al superamento delle prove pratiche e alla presenza al 100% delle ore previste.</p>

            <h2>6. Responsabilità</h2>
            <p>7MED svolge attività formativa e non sanitaria. La responsabilità di 7MED è limitata ai casi di dolo o colpa grave nei limiti previsti dal diritto svizzero (CO art. 100). Il partecipante dichiara di non avere controindicazioni mediche all'attività pratica.</p>

            <h2>7. Proprietà intellettuale</h2>
            <p>Tutti i contenuti del sito (testi, immagini, loghi, materiali didattici) sono di proprietà di 7MED GROUP o dei rispettivi licenzianti e protetti dal diritto d'autore svizzero.</p>

            <h2>8. Defibrillatori — vendita, noleggio, manutenzione</h2>
            <p>I dispositivi venduti sono coperti dalla garanzia del produttore. La manutenzione viene erogata secondo i contratti specifici sottoscritti. Il cliente è responsabile della collocazione e della corretta esposizione del dispositivo.</p>

            <h2>9. Foro competente</h2>
            <p>Il foro competente per qualsiasi controversia è quello di Mendrisio (Svizzera). Si applica il diritto svizzero.</p>

            <h2>10. Modifiche</h2>
            <p>7MED si riserva il diritto di aggiornare le presenti condizioni in qualsiasi momento. La versione vigente è quella pubblicata sul sito alla data di iscrizione.</p>
        </LegalLayout>
    );
}
